export const EFFICIENT_USER_ACTIONS = {
  FETCH_DATA: 'FETCH_EFFICIENT_USER_DATA',
  IMAGE_LOADED: 'EFFICIENT_USER_IMAGE_LOADED'
};

export const onImageLoad = () => ({
  type: EFFICIENT_USER_ACTIONS.IMAGE_LOADED
});